import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import contractorService from '../services/contractorService';

export const fetchContractors = createAsyncThunk(
  'contractors/fetchContractors',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await contractorService.getContractors(filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch contractors');
    }
  }
);

const initialState = {
  contractors: [],
  currentContractor: null,
  isLoading: false,
  error: null,
  filters: {
    skill: '',
    location: '',
    rating: 0
  }
};

const contractorSlice = createSlice({
  name: 'contractors',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setCurrentContractor: (state, action) => {
      state.currentContractor = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractors.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchContractors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contractors = action.payload.contractors;
      })
      .addCase(fetchContractors.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, setFilters, setCurrentContractor } = contractorSlice.actions;
export default contractorSlice.reducer;
